import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class UserService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    listUsers() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/usuarios/listausuarios`, { headers }).toPromise();
    }
    listUsuariosZonas() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/usuarios/listaUsuariosZonas`, { headers }).toPromise();
    }
    update(user, userId) {
        return this.http.put(`${this.configService.API_URL}/usuarios/${userId}`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    create(user) {
        return this.http.post(`${this.configService.API_URL}/usuarios`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    delete(userId) {
        return this.http.delete(`${this.configService.API_URL}/usuarios/${userId}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
}
UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: UserService, providedIn: "root" });
